import React, { useEffect, useState } from "react";
import { connect, ConnectedProps } from "react-redux";
import { applyAlliance, openDialog, setError } from "../../../store/actions";
import HintedInput from "../../Common/HintedInput";

interface IProps {
  elementRef: any;
}

const mapStateToProps = (state: any) => ({
  error: state.ui.error
});

const mapDispatchToProps = (dispatch: any) => ({
  openDialogDispatch: (dialogOptions: any) => dispatch(openDialog(dialogOptions)),
  applyAllianceDispatch: (allianceName: string) => dispatch(applyAlliance(allianceName)),
  setErrorDispatch: (error?: string) => dispatch(setError(error))
});

const connector = connect(mapStateToProps, mapDispatchToProps);

const ApplyAlliance = ({
  elementRef,
  error,
  openDialogDispatch,
  applyAllianceDispatch,
  setErrorDispatch
}: IProps & ConnectedProps<typeof connector>) => {
  const [allianceName, setAllianceName] = useState<string | null>(null)

  useEffect(() => {
    setErrorDispatch();
    return () => setErrorDispatch();
  }, [])

  return (
    <>
      <div className={"dialog-content"}>
        <table className="table">
          <tr>
            <td className={"no-border"}>Enter the name of alliance</td>
          </tr>
          <tr>
            <td className={"no-border"}>
              <HintedInput value={allianceName || ""} setValue={setAllianceName} searchArea={"alliance"} />
              {error && <span className={"negative"}>{error}</span>}
            </td>
          </tr>
        </table>
      </div>
      <div className={"dialog-footer"}>
        <a
          href="#"
          onClick={() => openDialogDispatch({
            name: "AllianceActions",
            header: "Join the alliance",
            clear: true,
            elementRef
          })}
          className="btn btn-blank btn-no-width"
        >
          Back
        </a>
        <button
          onClick={() => applyAllianceDispatch(allianceName || "")}
          className="btn btn-blank btn-no-width"
          disabled={!allianceName}
        >
          Ask
        </button>
      </div>
    </>
  )
}

export default connector(ApplyAlliance);
